import React from 'react';
import DayColumn from './DayColumn';

const WeekGrid = ({ 
  weekDates, 
  posts,
  holidays = [],
  onPostClick, 
  onPostEdit, 
  onPostDuplicate, 
  onPostDelete 
}) => {
  const getPostsForDate = (date) => {
    return posts.filter(post => {
      const postDate = new Date(post.scheduledDate);
      return (
        postDate.getFullYear() === date.getFullYear() &&
        postDate.getMonth() === date.getMonth() &&
        postDate.getDate() === date.getDate()
      );
    });
  };

  const getHolidaysForDate = (date) => {
    const dateStr = formatDateString(date);
    return holidays.filter(holiday => holiday.date === dateStr);
  };

  const formatDateString = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const isToday = (date) => {
    const today = new Date();
    return (
      date.getFullYear() === today.getFullYear() &&
      date.getMonth() === today.getMonth() &&
      date.getDate() === today.getDate()
    );
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
      {/* Optional: Time markers on the left */}
      <div className="flex">
        {/* Time Column (optional, can be removed if not needed) */}
        <div className="w-16 border-r border-gray-200 bg-gray-50">
          <div className="h-[60px] border-b border-gray-200"></div>
          {['12 AM', '6 AM', '12 PM', '6 PM'].map((time, idx) => (
            <div 
              key={time} 
              className="h-[150px] border-b border-gray-100 text-xs text-gray-400 p-2 text-center"
            >
              {time}
            </div>
          ))}
        </div>

        {/* Week Days Grid */}
        <div className="flex-1 flex overflow-x-auto">
          {weekDates.map((date, index) => (
            <DayColumn
              key={index}
              date={date}
              posts={getPostsForDate(date)}
              holidays={getHolidaysForDate(date)}
              isToday={isToday(date)}
              onPostClick={onPostClick}
              onPostEdit={onPostEdit}
              onPostDuplicate={onPostDuplicate}
              onPostDelete={onPostDelete}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default WeekGrid;
